<template lang="pug">
#detail.comAll(v-dragDiv,v-show="!actionData.isMini")
  .title.moveDragDiv
    span {{actionData.cnName}}
    i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
    i.el-icon-close(title='关闭' @click='closeAdd')
  .nav
    notationDetail(ref="notationDetail" :questionId="actionData.questionId" @startScreenShot="startScreenShot" :type='type')
</template>

<script>
import notationDetail from "@/views/mongeView/question/notationDetail.vue";
import kscreenshot from '@/CommonDP/utils/kscreenshot/src/kss.js';
import html2canvas from 'html2canvas';
export default {
  components: { notationDetail },
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default() {
        return "";
      }
    }
  },
  methods: {
    miniCom() {
      this.$emit("closeCom", 'detail', true);
    },
    closeAdd() {
      this.$emit("closeCom", 'detail', false);
    },
    // 文件截图
    async startScreenShot (call) {
      this.kss = new kscreenshot({
        endCB: (base64) => {
          call.callback(base64);
        },
        cancelCB: () => {
          // debugger
        }
      });
      switch (this.type) {
        case 'pdf':
          const pdfBox = this.$parent.$parent.$refs.iframeID;
          pdfBox.contentWindow.postMessage('cut');
          window.cutCallback = (el) => {
            html2canvas(el, { useCORS: true, allowTaint: true }).then((canvas) => {
              this.kss.startScreenShot(canvas);
            });
          };
          break;
        case 'txt':
          const txtBox = this.$parent.$parent.$refs.txt;
          html2canvas(txtBox, { useCORS: true })
            .then((canvas) => {
              this.kss.startScreenShot(canvas);
            });
          break;
        case 'image':
          const imageBox = this.$parent.$parent.$refs.image;
          html2canvas(imageBox, { useCORS: true })
            .then((canvas) => {
              this.kss.startScreenShot(canvas);
            });
          break;
        case 'office':
          const officeBox = this.$parent.$parent.$refs.iframeID;
          const dom = officeBox.src.includes(location.host) ? officeBox?.contentWindow?.document.body : officeBox;
          html2canvas(dom, { useCORS: true })
            .then((canvas) => {
              this.kss.startScreenShot(canvas);
            });
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#detail{
  position: fixed;
  top: 35px;
  right: 330px;
  width: 360px;
  height: calc(100% - 90px);
  max-height: 870px;
  .nav{
    height: calc(100% - 50px);
    overflow-y: auto;
  }
}
</style>
